module.exports = __webpack_public_path__ + "img/bea-csabi.212ce0c6.jpg";